class SwiperSlider extends HTMLElement {
  /**
   * The constructor for the SwiperSlider component.
   *
   * This function is called whenever a new instance of the SwiperSlider is
   * created. It reads the initial configuration from the component's attributes
   * and builds the Swiper instance.
   *
   * @param {Object} [options={}] - The options for the Swiper instance.
   */
  constructor() {
    super();
    this.swiper = null;
    this.dataOptions = this.dataOptions =
      JSON.parse(this.querySelector("[type='application/json']").textContent) ||
      {};

    this._init();
  }

  /**
   * Initializes the SwiperSlider component.
   *
   * This function reads the initial configuration from the component's attributes
   * and builds the Swiper instance.
   *
   * @private
   */
  _init() {
    this._buildSwiper();
  }

  /**
   * Builds the Swiper instance.
   *
   * This function creates a new instance of the Swiper component using the
   * selector and options set in the `_setValues` method. The Swiper instance
   * is not stored anywhere, so it will be garbage collected once the
   * component is destroyed.
   *
   * @private
   */
  _buildSwiper() {
    document.addEventListener("DOMContentLoaded", () => {
      this.swiper = new Swiper(this, this.dataOptions);
    });
  }
  destroy() {
    this.swiper.destroy(true, true);
  }
  initOnIndex(index) {
    this.swiper = new Swiper(this, {
      ...this.dataOptions,
      initialSlide: index,
    });
  }
}

customElements.define("swiper-slider", SwiperSlider);
